<template>
  <div>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>
        Users
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row v-if="showSearch" align="center" style="max-width: 300px;">
        <v-text-field flat hide-details single-line
          label="Search name, email or phone number" class="hidden-sm-and-down"
          v-model="filter.search" @input="search"
        ></v-text-field>
      </v-row>
      <v-btn class="ml-5" icon @click="showSearch = !showSearch">
        <img src="@/assets/icons/search.svg" alt="">
      </v-btn>
    </v-app-bar>
    <div class="ma-4" id="user-list">
      <v-simple-table>
        <thead>
          <tr>
            <th width="1%" class="text-left">Name</th>
            <th></th>
            <th class="text-left">Email</th>
            <th class="text-left">Phone number</th>
            <th class="text-left">Account Status</th>
            <th class="text-left">Added date</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users"
            :key="user.id"
            class="clickable"
            @click="$router.push({name: 'user.details', params: {id: user.id}})"
            >
            <td class="py-4">
              <user-avatar :avatar="user.avatar" size="36"/>
            </td>
            <td>
              <text-highlight :queries="filter.search">
                {{ user.full_name }}
              </text-highlight>
            </td>
            <td>
              <text-highlight :queries="filter.search">
                {{ user.email }}
              </text-highlight>
            </td>
            <td>
              <text-highlight :queries="filter.search">
                {{ user.phone_number ? user.phone_number : '' }}
              </text-highlight>
            </td>
            <td class="text-uppercase">
              <text-highlight :queries="filter.search">
                {{ user.account_status }}
              </text-highlight>
            </td>
            <td>{{ user.addedDate }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>
    </div>
    <div class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="paginationLength"
        :total-visible="10"
        circle
      ></v-pagination>
    </div>
    <profile-dialog v-model="showProfile" :profile="selectedProfile" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mdiDotsVertical, mdiUnfoldMoreHorizontal, mdiMagnify, mdiAccountCircleOutline, mdiChevronRight } from '@mdi/js'
import ProfileDialog from '@/components/ProfileDialog'
import debounce from 'lodash/debounce'
import TextHighlight from 'vue-text-highlight'
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'UsersPage',

  components: {
    ProfileDialog,
    TextHighlight,
    UserAvatar
  },

  data () {
    return {
      loading: false,
      showSearch: false,
      showProfile: false,
      selectedProfile: null,
      filter: {
        search: ''
      },
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight
      }
    }
  },

  computed: {
    ...mapState({
      users: state => state.user.list,
      listMeta: state => state.user.listMeta
    }),

    paginationLength () {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  },

  methods: {
    ...mapActions({
      getUsers: 'user/getUsers'
    }),

    pageChanged (page) {
      this.fetchUsers(page)
    },

    search: debounce(function () {
      this.fetchUsers()
    }, 600),

    async fetchUsers (page = 1) {
      let params = { page }
      if (this.filter.search) {
        params.search = this.filter.search
      }
      this.loading = true
      await this.getUsers(params)
      this.loading = false
    },

    showProfileDialog (profile) {
      this.selectedProfile = profile
      this.showProfile = true
    }
  },

  created () {
    this.fetchUsers()
  }
}
</script>

<style>

</style>
